import React from 'react';
import {Dialog} from 'components/core';
import api from 'controllers/raymanAPI';

interface APIResponseEvt
{
    method: "GET" | "POST" | "PUT" | "PATCH" | "DELETE",
    path: string,
    queryParams: any[],
    response: Response
}

export default function ApiErrorDialog()
{
    const [status, setStatus] = React.useState({open: false, errorMsg: ""});

    React.useEffect( function handleApiErrorEvents() {

        const checkResponse = async (apiResponse : APIResponseEvt) => {
            if(!apiResponse.response.ok)
            {
                let message = apiResponse.response.status + " " + apiResponse.response.statusText;
                let parsed = await apiResponse.response.json();
                if(parsed && parsed.message) message = parsed.message;
                setStatus({open: true, errorMsg: message});
            }
        }

        api.internalApi.on('response', checkResponse);
        
        return () => {
            api.internalApi.off('response', checkResponse);
        }

    }, []);

    const handleClose = () => 
    {
        setStatus({open: false, errorMsg: ""});
    }

    return <Dialog open={status.open} title="Algo ha ido mal" confirm="Aceptar" onConfirm={()=>handleClose()} onClose={()=>handleClose()}>
        {status.errorMsg}
      </Dialog>
}